module.exports = __webpack_public_path__ + "static/media/size_16_off.c080a573.svg";